import * as actionTypes from '../Actions/ActionTypes';
const intialState = {
    gradeList : [],
    subjectList : [],
    boardList : [],
    appliedGradeFilter : []
}

const filterMenu = (state = intialState,action) => {
    switch(action.type){
        case actionTypes.GET_GRADE_LIST : {
            return {
                ...state,
                gradeList : action.gradeList
            }
        }
        break;
        case actionTypes.GET_SUBJECTS_LIST : {
            return {
                ...state,
                subjectList : action.subjectList
            }
        }
        break;
        case actionTypes.GET_BOARD_LIST : {
            return {
                ...state,
                boardList : action.boardList
            }
        }
        break;
       
        default : 
            return state;
    }
}

export default filterMenu;